import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import 'react-image-lightbox/style.css';
import ConferencePhotoGalleryContentImage from '@components/ConferencePhotoGallery/ConferencePhotoGalleryContentImage';
import ConferencePhotoGalleryTab from '@components/ConferencePhotoGallery/ConferencePhotoGalleryTab';
import ConferencePhotoGalleryStatic from '@components/ConferencePhotoGalleryStatic/ConferencePhotoGalleryStatic';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import { Tabs, Title, TitleSymbol, Wrapper } from './ConferencePhotoGallery.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferencePhotoGalleryTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    const [activeSection, setActiveSection] = useState('previousTab0');

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.PHOTOGALLERY}`} colors={colors}>
            <Title colors={colors}>
                {t('conference.component.photogallery.title')} <TitleSymbol colors={colors} />
            </Title>

            {conf?.conference?.static_gallery?.length > 0 ? (
                <ConferencePhotoGalleryStatic conf={conf}/>
            ) : (

                <>
                    {conf?.conference?.galleries.length > 0 && (
                        <>
                            <Tabs>
                                {conf?.conference?.galleries.map((item, index) => (
                                    <ConferencePhotoGalleryTab
                                        key={`previousTab${index}`}
                                        colors={colors}
                                        gallery={item}
                                        activeSection={activeSection}
                                        setActiveSection={setActiveSection}
                                        index={index}
                                    />
                                ))}
                            </Tabs>

                            {conf?.conference?.galleries.map((item, index) => (
                                <ConferencePhotoGalleryContentImage
                                    key={`previousContent${index}`}
                                    colors={colors}
                                    gallery={item._key}
                                    activeSection={activeSection}
                                    setActiveSection={setActiveSection}
                                    index={index}
                                />
                            ))}
                        </>
                    )}
                </>

            )}
        </Wrapper>
    );
};

export default ConferencePhotoGalleryTemplate;
